import React from 'react';
import {
  CardContentWrapper,
  CardWrapper,
  NoResultsHeader,
  NoResultsWrapper,
  VehicleData,
  ViewAllResults,
} from './SidewideSearch.styles';
import { Card, Headline, Icon, Text } from '@oneaudi/unified-web-components';
import { HOST_NAME } from '../../constants';

interface NoResultsProps {
  isError?: boolean;
  language?: string;
  market?: string;
}

const NoResults: React.FC<NoResultsProps> = ({ isError, language, market }) => {
  const isFrench = language === 'fr';
  const title = isError
    ? isFrench
      ? 'Les résultats n’ont pas pu être chargés.'
      : 'Results couldn’t be loaded.'
    : isFrench
      ? 'Aucun résultat disponible pour le moment.'
      : 'No matches available at this time.';
  const description = isError
    ? isFrench
      ? 'Veuillez réessayer ou consulter toutes les options disponibles sur nos pages de véhicules.'
      : 'Try again, or browse all available options on our vehicle listing pages.'
    : isFrench
      ? 'Veuillez consulter toutes les options disponibles sur nos pages de véhicules.'
      : 'Please browse all available options on our vehicle listing pages.';
  const inventoryText = isFrench ? 'Voir l’inventaire' : 'View inventory';

  const newVlpUrl = `${HOST_NAME}/en/inventory/new/`;
  const usedVlpUrl = `${HOST_NAME}/en/inventory/used/#type=used&availableInMonths=0&usedInventoryType=has-warranties.combined`;
  const cpoVlpUrl = `${HOST_NAME}/en/inventory/used/#type=used&availableInMonths=0&usedInventoryType=has-warranties.yes`;
  return (
    <NoResultsWrapper data-testid="no-results">
      <NoResultsHeader>
        <Headline
          tag="h3"
          variant={{
            order: '3',
            type: 'headline',
            weight: 'normal',
          }}
        >
          {title}
        </Headline>
        <Text>{description}</Text>
      </NoResultsHeader>

      <CardWrapper tabIndex={0} href={newVlpUrl} vlpCard data-testid="no-results-new-vlp">
        <Card className="no-results-card-inner" margin={[0, 0, 0, 0]}>
          <CardContentWrapper>
            <Icon name="traffic" size="l" />
            <VehicleData gap={4}>
              <Text>{isFrench ? 'Véhicule neuf' : 'New vehicle'}</Text>
              <ViewAllResults>
                <Text>{inventoryText}</Text>
                <Icon name="forward" size="s" />
              </ViewAllResults>
            </VehicleData>
          </CardContentWrapper>
        </Card>
      </CardWrapper>
      <CardWrapper tabIndex={0} href={usedVlpUrl} vlpCard data-testid="no-results-used-vlp">
        <Card className="no-results-card-inner" margin={[0, 0, 0, 0]}>
          <CardContentWrapper>
            <Icon name="traffic" size="l" />
            <VehicleData gap={4}>
              <Text>{isFrench ? 'Véhicule d’occasion' : 'Pre-owned vehicle'}</Text>
              <ViewAllResults>
                <Text>{inventoryText}</Text>
                <Icon name="forward" size="s" />
              </ViewAllResults>
            </VehicleData>
          </CardContentWrapper>
        </Card>
      </CardWrapper>
      <CardWrapper tabIndex={0} href={cpoVlpUrl} vlpCard data-testid="no-results-cpo-vlp">
        <Card className="no-results-card-inner" margin={[0, 0, 0, 0]}>
          <CardContentWrapper>
            <Icon name="traffic" size="l" />
            <VehicleData gap={4}>
              <Text>
                {isFrench
                  ? 'Véhicule certifié :plus'
                  : `Certified ${market !== 'us' ? ':plus' : 'Pre-owned'} vehicle`}
              </Text>
              <ViewAllResults>
                <Text>{inventoryText}</Text>
                <Icon name="forward" size="s" />
              </ViewAllResults>
            </VehicleData>
          </CardContentWrapper>
        </Card>
      </CardWrapper>
    </NoResultsWrapper>
  );
};

export default NoResults;
